<template>
    <div data-cy="container_category_slider">
        <div class="flex overflow-y-auto select-none" data-cy="list_category_slider">
            <div class="flex-shrink-0 w-40 p-2"
                 v-for="(cat, k) in catList"
                 :key="k">
                <div class="text-center py-2 cursor-pointer rounded-md bg-blue-400 text-white"
                     v-if="k == activeIndex"
                     :data-cy="`card_category_slider_tab_active_${k}`">
                    {{catName(cat)}}
                </div>
                <div class="text-center py-2 cursor-pointer rounded-md bg-gray-100 text-black"
                     v-else
                     @click="clickTab(k)"
                     :data-cy="`btn_category_slider_tab_${k}`">
                    {{catName(cat)}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';

export default {
    name: 'CatSlider',
    mixins: [LocaleMixin],
    props: {
        catList: { type: Array, required: true },
    },
    data: function() {
        return {
            activeIndex: 0,
            slide: {
                isDown: false,
                startX: 0,
                scrollLeft: 0,
            },
        };
    },
    created: function() {
        this.setDefaultTab();
    },
    methods: {
        setDefaultTab: function() {
            let catId = this.$route.params.catId;

            if (!Util.isEmptyStr(catId)) {
                for (let i in this.catList) {
                    if (this.catList[i].id == catId) {
                        this.activeIndex = i;
                        break;
                    }
                }
            }
        },
        catName: function(cat) {
            return this.localeCode == 1033 ? cat.nameEn : cat.nameTh;
        },
        clickTab: function(index) {
            this.activeIndex = index;
            let send = {
                index: index,
                cat: this.catList[index],
            };
            this.$emit('clickTab', send);
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
